const TO_CNPJ = value => {
  return value ? `${value.slice(0, 2)}.${value.slice(2, 5)}.${value.slice(5, 8)}/${value.slice(8, 12)}-${value.slice(12, 14)}` : value;
}


export default {
  TO_CNPJ
};
